export const CVQuality = {
  low: 'low',
  mid: 'mid',
  high: 'high'
}
export type CVQuality = typeof CVQuality[keyof typeof CVQuality]


export interface CVRoasterResponse {
  CV_quality: CVQuality
  points_of_improvement: string[]
}

export interface CVRoasterResult {
  cvId: number
  cvUrl: string
  analysis: CVRoasterResponse
}
